import {NgModule} from '@angular/core';
import {ToastrModule} from 'ngx-toastr';
import {JsonPipe, NgIf} from "@angular/common";
import {CustomToasterComponent} from "@core/libs";

@NgModule({
  declarations: [CustomToasterComponent],
  imports: [
    ToastrModule.forRoot({
      toastComponent: CustomToasterComponent
    }),
    NgIf,
    JsonPipe
  ],
})
export class NgxToastRootModule {
}
